<template>
  <v-img
    src="../assets/eventlogo.png"
    max-width="1075px"
    class="ma-auto w-100 w-md-80"
  >
    <template #sources>
      <source srcset="../assets/eventlogo.png" />
    </template>
  </v-img>
  <div>
    <p class="catch text-h4 text-md-h3 text-secondary">
      2026年2月1日(日)<br />時間:11時～16時
    </p>
  </div>
</template>
<style scoped>
  .catch {
    text-align: center;
    font-family: "rocknroll-one", sans-serif !important;
    font-weight: bold;
    font-style: normal;
    text-shadow: 0.04em 0.02em 0 #fff,
      0.08em 0.05em 0 rgb(var(--v-theme-secondary));
    line-height: 1.5em;
  }
</style>
